import Swiper, { Navigation, Pagination } from 'swiper'
import withResponsive from '../hoc/withResponsive'
import emitter from '../utils/emitter'

Swiper.use([Navigation, Pagination])

export default withResponsive({
  name: 'slider',

  ui: {
    slider: '[js-slider-el]',
  },

  componentDidMount () {
    this.nbMobile = this.props && this.props.nbMobile ? this.props.nbMobile : 1
    this.nbTablet = this.props && this.props.nbTablet ? this.props.nbTablet : 1
    this.nbDesktop = this.props && this.props.nbDesktop ? this.props.nbDesktop : 1

    const options = {
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 16,
      threshold: 10,
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
      observer: true,
      observeParents: true,
      pagination: {
        clickable: true,
        el: this.el.querySelector('.swiper-pagination'),
        type: 'bullets',
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: this.nbMobile,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: this.nbTablet,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: this.nbDesktop,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: this.nbDesktop,
          spaceBetween: 32,
        },
      },
    }

    if (this.props && this.props.loop) {
      options.loop = true
    }

    if (this.props && this.props.autoHeight) {
      options.autoHeight = true
    }

    /* eslint-disable-next-line */
    this.swiper = new Swiper(this.ui.slider, options)

    this.swiper.on('slideChange', () => {
      emitter.trigger('change_slide', {
        currentSlide: this.swiper.activeIndex,
        totalSlides: this.swiper.slides.length,
      })
    })
  },
})
